import { render, staticRenderFns } from "./people_list.vue?vue&type=template&id=16ca66b8&"
import script from "./people_list.vue?vue&type=script&lang=js&"
export * from "./people_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ca66b8')) {
      api.createRecord('16ca66b8', component.options)
    } else {
      api.reload('16ca66b8', component.options)
    }
    module.hot.accept("./people_list.vue?vue&type=template&id=16ca66b8&", function () {
      api.rerender('16ca66b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/people_list.vue"
export default component.exports